function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.8a.75.75 0 01-.75.75h-7.5a.75.75 0 110-1.5h7.5a.75.75 0 01.75.75zm3.75-12a8.207 8.207 0 01-3.154 6.488 1.523 1.523 0 00-.596 1.197v.565a1.502 1.502 0 01-1.5 1.5H9a1.502 1.502 0 01-1.5-1.5v-.565a1.502 1.502 0 00-.584-1.187A8.21 8.21 0 013.75 9.846c-.025-4.468 3.587-8.189 8.051-8.294A8.25 8.25 0 0120.25 9.8zm-3.074-.88a5.236 5.236 0 00-4.29-4.286.75.75 0 10-.25 1.48 3.735 3.735 0 013.061 3.056.75.75 0 001.48-.25z",
    fill: props.fill
  }));
}

export default SvgLightbulb;